const defaultSettings = require('@/utils/webSettings.js')
import crypt from '@/utils/crypt';

let storage = {
  setItem: function (key, value, cryptKey = crypt.keys.storageKey, cb) {
    value = value || '';

    if(value !== '' && typeof value == 'number'){
      value = value.toString()
    }

    //加密保存数据
    if(value && typeof value == 'object'){
      value = JSON.stringify(value);
    }
    let encodeData = crypt.encryptCX(value, crypt.enType.DES, cryptKey);
    localStorage.setItem(defaultSettings.env_title + "_" + key, encodeData);

    cb = cb || function () {};
    cb();

    return value;
  },
  getItem: function (key,cryptKey = crypt.keys.storageKey, cb) {
    let value = localStorage.getItem(defaultSettings.env_title + "_" + key);
    let decodeData = null;
    if (value) {
      decodeData = crypt.decryptCX(value, crypt.enType.DES, cryptKey)
    }

    cb = cb || function () {};
    cb();
    return decodeData;
  },
  removeItem: function (key, cb) {
    localStorage.removeItem(defaultSettings.env_title + "_" + key);

    cb = cb || function () {};
    cb();
  }
}

export default storage;
